import NumberInput from '../number-input';
import { messageBoxSuccess, messageBoxError } from '../message-box';
class BaseCart {
  public cart: HTMLElement | null;
  public removeItemButtons: NodeListOf<HTMLElement> | null;
  public selectionCount: HTMLElement | null;
  public total: HTMLElement | null;
  public totalQuick: HTMLElement | null;
  public totalTax: NodeListOf<HTMLElement> | null;
  public shippingPrice: HTMLElement | null;
  public subTotal: HTMLElement | null;
  public productsContainer: HTMLElement | null;
  public qtyInputs: NodeListOf<HTMLElement> | null;
  public checkoutButton: HTMLButtonElement | null;
  public messageBox: HTMLElement | null;
  public summary: HTMLElement | null;
  public isReadOnly: boolean = false;
  public canCheckout: boolean = true;
  public cartIconHeader: HTMLElement | null;
  public cartIconHeaderInner: SVGTSpanElement | null | undefined;

  constructor() {
    this.handleItemRemove = this.handleItemRemove.bind(this);
    this.handleLineItemStockChange = this.handleLineItemStockChange.bind(this);
  }

  cache() {
    if (this.cart) {
      this.productsContainer = this.cart.querySelector('.js-cart-products-container');

      this.total = this.cart.querySelector('.js-cart-total');
      this.totalQuick = this.cart.querySelector('.js-cart-total-quick');
      this.totalTax = this.cart.querySelectorAll('.js-cart-total-tax');
      this.selectionCount = this.cart.querySelector('.js-cart-selection-count');
      this.summary = this.cart.querySelector('.js-cart-summary');
      this.checkoutButton = this.cart.querySelector('.js-cart-checkout-btn');
      this.messageBox = this.cart.querySelector('.js-cart-message-box');
      this.shippingPrice = this.cart.querySelector('.js-cart-shipping-price');
      this.subTotal = this.cart.querySelector('.js-cart-subtotal');

      this.cartIconHeader = document.querySelector('.l-header__actions-button-cart .js-l-header__cart-icon');
      this.cartIconHeaderInner = this.cartIconHeader?.querySelector('tspan');
    }

    this.cacheRecurring();
  }

  cacheRecurring() {
    if (this.cart) {
      this.removeItemButtons = this.cart.querySelectorAll('.js-cart-remove-item');

      this.qtyInputs = this.cart.querySelectorAll('.js-number-input');
    }
  }

  bindings() {
    this.setBindings('add');

    document.addEventListener('cart:updated', () => {
      this.updateCart();
    });
  }

  handleItemRemove(e: Event) {
    e.preventDefault();

    const target = e.currentTarget as HTMLElement;

    if (target && target.dataset) {
      const lineId: string | undefined = target.dataset.lineId;

      const data = { [`lineItems[${lineId}][remove]`]: 'true' };

      this.handleLineItemUpdate(data);
    }
  }

  handleLineItemStockChange(e: Event) {
    const target = e.target as HTMLInputElement;

    const data = {
      [target.name]: target.value,
    };

    if (target.dataset.isConfigurator == 'true') {
      JSON.parse(target.dataset.configLineItems || '[]').forEach((lineItem: string) => {
        data[`lineItems[${lineItem}][qty]`] = target.value;
      });
    }

    this.handleLineItemUpdate(data);
  }

  handleLineItemUpdate(data: any) {
    const formData = new FormData();

    formData.append('action', 'commerce/cart/update-cart');

    Object.keys(data).forEach((key: any) => {
      formData.append(key, data[key]);
    });

    // @ts-ignore
    formData.append(window.csrfTokenName, window.csrfTokenValue);

    fetch('/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((jsonResponse) => {
        if (jsonResponse.success || jsonResponse.message === 'Warenkorb aktualisiert.') { //TODO Craft 4 refactoring: should just be a temporarly workaround
          // messageBoxSuccess({
          //   contentDe: jsonResponse.message,
          //   contentEn: jsonResponse.message,
          // });
          messageBoxSuccess({
            contentDe: 'Warenkorb wird aktualisiert',
            contentEn: 'Cart is being updated',
          });

          if (this.cartIconHeaderInner) {
            let sum = 0;
            let alreadyCounted: any[] = [];
            Object.keys(jsonResponse.cart.lineItems).forEach((lineItemKey: any) => {
              let lineItem = jsonResponse.cart.lineItems[lineItemKey];
              if ((lineItem && lineItem.qty) && (!lineItem.options?._configuratorId || lineItem.options?._configuratorMainItem === 'yes')) {
                sum += lineItem.qty;
              }
              if (lineItem && lineItem.qty) {
                alreadyCounted.push(lineItem.options?._configuratorId);
              }
            });
            this.cartIconHeaderInner.innerHTML = String(sum);
          }

          if (this.cartIconHeader && this.cartIconHeaderInner?.innerHTML == '0') {
            this.cartIconHeader.style.display = 'none';
          }
        } else {
          let errorList = '';

          if (jsonResponse.errors) {
            Object.values(jsonResponse.errors).forEach((errors: any) => {
              if (typeof errors === 'object') {
                Object.values(errors).forEach((error: any) => {
                  errorList += `<br/> ${error}`;
                });
              }
            });
          }

          const message = `${jsonResponse.error.replace('.', '')}: ${errorList}`;

          messageBoxError({
            contentDe: message,
            contentEn: message,
          });
        }

        if (!this.productsContainer) {
          location.reload();
        } else {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { showCart: false },
            } as any)
          );
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  updateCart() {
    return new Promise((resolve: Function) => {
      const apiBaseUrl = document.body.dataset.apiBaseUrl;
      fetch(`${apiBaseUrl}api/v1/cart`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((jsonResponse) => {
          this.setBindings('remove');

          this.render(jsonResponse);

          return resolve();
        });
    });
  }

  setBindings(bindingType: string) {
    if (this.removeItemButtons) {
      Object.values(this.removeItemButtons).forEach((removeItemButton: HTMLElement) => {
        if (bindingType === 'add') {
          removeItemButton.addEventListener('click', this.handleItemRemove);
        } else {
          removeItemButton.removeEventListener('click', this.handleItemRemove);
        }
      });

      if (this.qtyInputs) {
        Object.values(this.qtyInputs).forEach((qtyInput: HTMLElement) => {
          const input = qtyInput.querySelector('input');

          if (bindingType === 'add') {
            input?.addEventListener('change', this.handleLineItemStockChange);
          } else {
            input?.removeEventListener('change', this.handleLineItemStockChange);
          }
        });
      }
    }
  }

  render(data: any) {
    if (data.lineItems && this.productsContainer) {
      let html: string = '';

      if (data.lineItems.length > 0) {
        data.lineItems.forEach((lineItem: any) => {
          const lineItemStock: Number = lineItem.purchasable.hasUnlimitedStock ? 1000 : Number(lineItem.purchasable.stock);

          if (lineItemStock <= 0) {
            this.canCheckout = false;
          }
          if (!lineItem.isPurchasable) {
            this.canCheckout = false;
          }

          if (lineItem.options._configuratorLineItem && lineItem.options._configuratorMainItem != 'yes') {
            return;
          }

          html += lineItem.html + '<hr>';
        });

        this.productsContainer.innerHTML = html;

        this.summary?.classList.remove('d-none');

        this.cacheRecurring();
        this.setBindings('add');

        const numberInputs = new NumberInput(this.productsContainer.querySelectorAll('.js-number-input'));
        numberInputs.init();

        if (this.selectionCount) {
          this.selectionCount.innerText = data.lineItems.length;
        }

        if (data.total && this.total) {
          this.total.innerText = data.total;
        }

        if (data.subTotal && this.totalQuick) {
          this.totalQuick.innerText = data.subTotal;
        }

        if (data.totalTax && this.totalTax) {
          this.totalTax.forEach((totalTax) => {
            totalTax.innerText = data.totalTax;
          });
        }

        if (data.shippingPrice && this.shippingPrice) {
          this.shippingPrice.innerText = data.shippingPrice;
        }

        if (data.subTotal && this.subTotal) {
          this.subTotal.innerHTML = data.subTotal;
        }

        if (this.canCheckout) {
          this.checkoutButton?.classList.remove('is-disabled');
          this.messageBox?.classList.add('d-none');
        } else {
          this.checkoutButton?.classList.add('is-disabled');
          this.messageBox?.classList.remove('d-none');
        }
      } else {
        html = '<p class="align-center mt-9 mb-3">Warenkorb ist leer.</p>';

        this.productsContainer.innerHTML = html;

        if (this.selectionCount) {
          this.selectionCount.innerText = data.lineItems.length;
        }

        this.summary?.classList.add('d-none');
      }
    }

    if (!this.productsContainer) {
      location.reload();
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default BaseCart;
